'use strict';

var ClinicApp = angular.module('ClinicApp', [
  'angularMoment',
  'datePicker',
  'ngRoute',
  'ui.bootstrap',
  'resources',
  'filters',
  'constants',
  'security',
  'ui.router',
  'ngAnimate',
  'ngClipboard',
  'angularFileUpload',
  'ngImgCrop',
  'utils',
  'ui.calendar',
  'xeditable',
  'localytics.directives',
  'ngAutocomplete',
  'angular-growl',
  'angulartics',
  'angulartics.google.analytics',
  'datatables',
  'base64',
  'mgo-angular-wizard',
  'ngPageTitle',
  'duScroll',
  'validators',
  'LocalStorageModule',
  'taiPlaceholder',
  'ui.sortable',
  'pickadate',
  'ngSanitize',
  'ngCsv',
  'n3-line-chart',
]);

ClinicApp.factory(
  'httpResponseInterceptor',
  function(
    $q,
    GrowlService,
    OCLogUtil,
  ) {
    return {
      _responseError: function(response) {
        var errors = _.get(response, 'data.errors') || [];
        if (!_.isEmpty(errors)) {
          errors.forEach(function(error) {
            GrowlService.error(error);
          });
        } else {
          var message;
          switch (response.status) {
            case 400:
              message = 'The action you are trying to perform is invalid.';
              break;
            case 401:
              message = 'You must be logged in to perform this action.';
              break;
            case 403:
              message = "You don't have permission to perform this action.";
              break;
            case 404:
              message = "We can't find the action you're trying to perform.";
              break;
            case 500:
              OCLogUtil.rollbar.httpResponseError('API request error: 500', response);
              message = 'The system encountered an unknown error.';
              break;
            default:
              OCLogUtil.rollbar.httpResponseError('API request error: ' + response.status, response);
              message = 'The system encountered an unknown error.';
              break;
          }
          GrowlService.error(message);
        }
        return $q.reject(response);
      },
      get responseError() {
        return this._responseError;
      },
      set responseError(value) {
        this._responseError = value;
      },
    };
  },
);

ClinicApp.config(
  function(
    $httpProvider,
    growlProvider,
    $pageTitleProvider,
    $provide,
    localStorageServiceProvider,
    ClinicConfig,
    $sceDelegateProvider,
  ) {

    $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain. **.
      `${ClinicConfig.CLINIC_APP_V4_URL}/**`,
    ]);

    // Default page title.
    $pageTitleProvider.setDefault('Clinic - Opencare');

    // HTTP provider config.
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
    $httpProvider.defaults.headers.common['X-OC-App'] = 'clinic';
    $httpProvider.interceptors.push('httpResponseInterceptor');

    // Growl provider config.
    growlProvider.globalTimeToLive(5000);
    growlProvider.onlyUniqueMessages(true);
    growlProvider.globalDisableCountDown(true);

    // Decorate angular wizard, add a custom function to scope.
    $provide.decorator('wizardDirective', function($delegate) {
      var directive = $delegate[0];
      var previousLink = directive.link;

      // Allow the title to be passed in for the navigation
      directive.scope.stepsTitle = '=';

      directive.compile = function() {
        return function($scope, el) {
          var injector = el.injector();
          var $state = injector.get('$state');
          var $stateParams = injector.get('$stateParams');

          $scope.stateStep = function(step) {
            if (!$stateParams.step) {
              return;
            }

            $state.go($state.current.name, {
              id: $stateParams.id,
              step: step,
            });
          };

          if (previousLink) {
            previousLink.apply(this, arguments);
          }
        };
      };

      return $delegate;
    });

    // Local storage configuration.
    localStorageServiceProvider.setPrefix('clinic.opencare');
    localStorageServiceProvider.setStorageType('localStorage');
    localStorageServiceProvider.setStorageCookieDomain(ClinicConfig.COOKIES_DOMAIN);
  },
);

ClinicApp.config(function($stateProvider, $urlRouterProvider) {
  // Custom rule to always add a trailing slash. c/o:
  // https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions#how-to-make-a-trailing-slash-optional-for-all-routes
  $urlRouterProvider.rule(function(_$injector, $location) {
    var path = $location.url();
    if (path[path.length - 1] === '/' || path.indexOf('/?') > -1) {
      return;
    }
    if (path.indexOf('?') > -1) {
      return path.replace('?', '/?');
    }
    return path + '/';
  });

  $urlRouterProvider.when('', '/');
  $urlRouterProvider.when('/reserved-slots-faq/', '/instant-book-faq/');

  $urlRouterProvider.otherwise(function($injector) {
    $injector.invoke(function($state) {
      $state.transitionTo('404');
    });
  });

  $stateProvider.state('home', {
    url: '/',
    params: {
      onboarding: '',
    },
    controller: function() {},
    resolve: {
      redirect: function($location, CurrentUser, $timeout, $stateParams) {
        return CurrentUser.waitForUserLoad(CurrentUser.isAuthenticated).then(function(authenticated) {
          // We are in the middle of a location change, so,
          // our $location.replace() has to run on the next digest.
          function redirectToPath(path) {
            $timeout(function() {
              $location.path(path).search($stateParams)
                .replace();
            });
          }

          if (authenticated) {
            var clinics = CurrentUser.getClinics();
            if (clinics && clinics.length > 0) {
              return redirectToPath('/clinic/' + clinics[0].id + '/');
            }

            var doctors = CurrentUser.getDoctors();
            if (doctors && doctors.length > 0) {
              return redirectToPath('/doctor/' + doctors[0].id + '/');
            }

            return redirectToPath('/clinic/create/');
          }

          return redirectToPath('/login/');
        });
      },
    },
  });

});

// Extending $exceptionHandler.
ClinicApp.config(function($provide) {
  $provide.decorator('$exceptionHandler', function($delegate, OCLogUtil) {
    return function(exception, cause) {
      // Default behavior.
      $delegate(exception, cause);

      // Rollbar.
      OCLogUtil.rollbar.error(exception);
    };
  });
});

ClinicApp.run(function(
  $rootScope,
  $transitions,
  $document,
  $location,
  $timeout,
  $state,
  $stateParams,
  ResolverCodes,
  ClinicConfig,
  editableOptions,
  editableThemes,
  OCDomUtil,
  localStorageService,
  OCLogUtil,
  OCAnalyticsUtil,
  OpencareConstants,
  OCChatWidgetUtil,
) {
  // Remove `auth` param to avoid accidental sharing.
  $location.search('auth', null).replace();

  $rootScope.config = ClinicConfig;
  $rootScope.monthlyBillingConfig = OpencareConstants.automatedBilling;
  $rootScope.copyrightText = 'Opencare © 2012-' + new Date().getFullYear();
  $rootScope.flashAvailable = OCDomUtil.isFlashAvailable();
  $rootScope.isCurrentState = function(stateName) {
    return $state.is(stateName);
  };

  // Rollbar.
  if (window.Rollbar) {
    Rollbar.configure({
      payload: {
        environment: ClinicConfig.ENV,
        client: {
          javascript: {
            source_map_enabled: true,
            // `window.rollbarRevision` is setup as a part of "rollbarSourceMaps" Grunt task.
            code_version: window.rollbarRevision,
            guess_uncaught_frames: true,
          },
        },
      },
      transform: function(payload) {
      // Add the FullStory session URL to the Rollbar payload
        if (window.FS && window.FS.getCurrentSessionURL) {
          payload.fullstorySessionURL = window.FS.getCurrentSessionURL(true);
        }

        // Add the Heap User ID and Session ID to the Rollbar payload
        if (window.heap && window.heap.userId) {
          payload.heapUserId = window.heap.userId;
          payload.heapSessionId = window.heap.getSessionId();
        }
        return payload;
      },
    });
  } else if (ClinicConfig.ENV === 'development') {
    throw new Error('Rollbar did not load in development environment');
  }

  // Initialize Opencare Analytics
  OpencareAnalytics.initialize({
    appId: `clinic-v3:${ClinicConfig.ENV}`,
    environment: ClinicConfig.ENV,
    ocApiUrl: ClinicConfig.HOSTNAME,

    pixels: {
      // These pixels are enabled by default
      // but we'll explicitly enable them here for clarity
      [OpencareAnalytics.pixelNames.FULLSTORY]: true,
      [OpencareAnalytics.pixelNames.HEAP]: true,
      [OpencareAnalytics.pixelNames.SNOWPLOW]: true,
      [OpencareAnalytics.pixelNames.OPENCARE]: true,

      // These pixels are disabled by default
      [OpencareAnalytics.pixelNames.STATSIG]: true,
    },
  });

  // Enable Appcues
  OCAnalyticsUtil.bootUserAnalytics();

  function redirectToPath(path, queryParams) {
    $timeout(function() {
      $location.path(path).search(queryParams || $location.search())
        .replace();
    });
  }

  function transitionToState(state, params) {
    $timeout(function() {
      $state.transitionTo(state, params);
    });
  }

  var disableActiveEditorStates = ['clinic-setup'];

  $transitions.onStart({}, function(transition) {
    const toState = transition.to();
    const fromState = transition.from();

    // Remove any popovers. (inspector gadget html popover plugin lingers)
    angular.element('.popover').remove();

    // Variable on root scope which can infer if the base state name changed (useful for some directives)
    $rootScope.sameBaseStateChange = fromState.name.split('.')[0] == toState.name.split('.')[0];

    // Find all uncompleted editing on the current view and notify a user.
    var activeEditorSelectors = [
      'form[data-editable-form]:not(.editable-form-disable-dirty)',
      'form[editable-form]:not(.editable-form-disable-dirty)',
      '.edit .form-control',
    ];
    var activeEditors = $document.find(activeEditorSelectors.join(',')).filter(':visible');

    // Async code cannot be used here so the native `confirm` is the best choice.
    if (activeEditors.length && disableActiveEditorStates.indexOf(fromState.name) == -1 && !confirm('You have unsaved changes on this page. Do you want to continue and discard these changes?')) {
      event.preventDefault();

      // Refocus on the last active editor.
      activeEditors[activeEditors.length - 1].focus();
    }
  });

  // Capture all URL changes
  $rootScope.$on('$locationChangeSuccess', function() {
    OpencareAnalytics.trackDefaultPageView();
  });

  $rootScope.$on('$locationChangeSuccess', function(_event, newUrl, oldUrl) {
    if (newUrl != oldUrl && window.Appcues) {
      window.Appcues.page();
    }
  });

  $transitions.onSuccess({}, function(transition) {
    const toState = transition.to();
    const toParams = transition.params();
    const fromState = transition.from();

    const toStateData = toState.data || {};
    const fromStateData = fromState.data || {};

    $rootScope.hideNavigation = Boolean(toStateData.hideNavigation);
    $rootScope.whiteBackground = Boolean(toStateData.whiteBackground);
    $rootScope.wrapperClasses = String(toStateData.wrapperClasses || '');
    $rootScope.wizardView = Boolean(toStateData.wizardView);
    $rootScope.showSearchFooter = Boolean(toStateData.showSearchFooter);

    // Called by clinic-v4 (via IframeService's function-call bridge) to hide/show the site-wide Zendesk widget.
    $rootScope.hideChatWidget = OCChatWidgetUtil.hide;
    $rootScope.showChatWidget = OCChatWidgetUtil.show;

    const noScrollOnSearch = toStateData.noScrollOnSearch
      && fromStateData.noScrollOnSearch
      && fromState.name === toState.name;
    if (!noScrollOnSearch) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    if (toParams.click) {
      // To avoid repeated clicks need to reset `click` parameter because it's stored across state transitions.
      $stateParams.click = null;
      OCDomUtil.clickAndFocusOn(toParams.click);
    }
  });

  var notAuthenticatedRedirectLimit = 5;
  var notAuthenticatedRedirectCurrent = 0;

  $transitions.onError({}, function(transition) {
    const toState = transition.to();
    const toParams = transition.params();
    const fromState = transition.from();
    const fromParams = fromState.params;
    const error = transition.error();

    const TRANSITION_ERROR_TYPES = {
      IGNORED: 5,
      SUPERSEDED: 2,
      ABORTED: 3,
      INVALID: 4,
      ERROR: 6,
    };

    const IGNORED_ERROR_TYPES = [
      TRANSITION_ERROR_TYPES.IGNORED,
      TRANSITION_ERROR_TYPES.SUPERSEDED,
    ];
    if (IGNORED_ERROR_TYPES.includes(error?.type)) {
      console.warn('Ignored state transition error', error);
      return;
    }

    // Ignore HTTP rejections (e.g. API request errors).
    if (error && !error?.headers) {
      OCLogUtil.rollbar.error('Error occured during state transition', {
        error,
        event,
        toState,
        toParams,
        fromState,
        fromParams,
      });
    }

    switch (error?.detail) {
      case ResolverCodes.isAuthenticated:
        redirectToPath('/');
        break;
      case ResolverCodes.notAuthenticated:
        if (notAuthenticatedRedirectCurrent < notAuthenticatedRedirectLimit) {
          notAuthenticatedRedirectCurrent++;
          redirectToPath('/login/', {
            nextUrl: encodeURIComponent($location.$$url),
          });
        } else {
          notAuthenticatedRedirectCurrent = 0;
          transitionToState('home');
        }
        break;
      case ResolverCodes.forbidden:
        transitionToState('403');
        break;
      case ResolverCodes.notFound:
        transitionToState('404');
        break;
      default:
        transitionToState('404');
        break;
    }
  });

  // X-editable
  editableOptions.theme = 'bs3';
  editableOptions.blurElem = 'ignore';
  editableThemes.bs3.buttonsTpl = '<div class="editable-buttons clearfix"></div>';
  editableThemes.bs3.submitTpl = '<button type="submit" class="btn btn-primary btn-block-xs m-l-xs pull-right">Save</button>';
  editableThemes.bs3.cancelTpl = '<button type="button" class="btn btn-cancel btn-block-xs pull-right" data-ng-click="$form.$cancel()" onclick="event.stopPropagation();">Cancel</button>';

  // Is used in the search project to identify clinic users.
  // https://www.pivotaltracker.com/story/show/106895206
  localStorageService.cookie.set('suspectedClinicUser', 'true');

  // Load Google Maps API.
  $.getScript('https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&language=en&key=' + ClinicConfig.GOOGLE_MAPS_API_KEY);
});

// Bootstrapping the patient angular app manually.
// It's required in cases when `auth` query parameter is provided
// and we want to authenticate the user before all other angular routine.
// Angular doesn't provide built-in mechanism for bootstrapping application in async mode,
// so this is the only way to do that.
(function() {
  function bootstrapApp() {
    angular.element(document).ready(function() {
      angular.bootstrap(document, ['ClinicApp']);
    });
  }

  // Parse `auth` query param manually because we can't inject `$location` or `$routeParams` here.
  var qs = (window.location.hash || '').split('?')[1] || '';
  var authParam = null;
  angular.forEach(qs.split('&'), function(keyValueStr) {
    var keyValue = keyValueStr.split('=');
    if (decodeURIComponent(keyValue[0]) == 'auth') {
      authParam = keyValue[1];
    }
  });

  if (authParam) {
    var injector = angular.injector(['ng', 'config', 'base64']);
    var $base64 = injector.get('$base64');
    var authData = null;

    try {
      authData = angular.fromJson($base64.decode(decodeURIComponent(decodeURIComponent(authParam))));
    } catch (_err) {
      // Do nothing for some reason...
    }

    if (!authData) {
      return bootstrapApp();
    }

    var $http = injector.get('$http');
    var ClinicConfig = injector.get('ClinicConfig');
    var headers = {
      'X-OC-App': 'clinic',
    };

    $http.post(ClinicConfig.HOSTNAME + '/loginToken', {
      email: authData.email,
      token: authData.token,
    }, {
      headers: headers,
      withCredentials: true,
    }).catch(function(response) {
      // If the user is already logged in as somebody else, log them out and try again
      if (response.status == 403) {
        return $http.post(ClinicConfig.HOSTNAME + '/logout', {}, {
          headers: headers,
          withCredentials: true,
        })
          .then(() => {
            return $http.post(ClinicConfig.HOSTNAME + '/loginToken', {
              email: authData.email,
              token: authData.token,
            }, {
              headers: headers,
              withCredentials: true,
            });
          });
      } else {
        throw response;
      }
    })
      .finally(() => {
        bootstrapApp();
      });
  } else {
    bootstrapApp();
  }
}());
